export const anchorScroll = () => {
  const urlHash = location.hash;
  const header = document.getElementById("header");
  const headerHeight = header ? header.clientHeight : 0; // clientHeight は padding 含む高さ

  // ハッシュがある場合は一旦一番上にスクロールしてからターゲットへ移動
  if (urlHash) {
    // 即時にトップへスクロール（既存のスクロールがあれば強制的に停止）
    window.scrollTo(0, 0);
    setTimeout(() => {
      const target = document.querySelector(urlHash);
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    }, 500);
  }

  // aタグで href が "#" から始まる要素に対してクリックイベントを設定
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (event) {
      event.preventDefault();
      const href = anchor.getAttribute("href");
      const target = document.querySelector(href);
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });
};
